export default __webpack_public_path__ + "static/media/u.9da6cbd0.mp4";